import { useServices } from "./useServices.js";
const useImageRotator = ()=>useServices().imageRotator;
export { useImageRotator };
